import { MutationTree } from 'vuex';
import { I18nMutations, I18nState } from './types';

export const mutations: MutationTree<I18nState> = {
  [I18nMutations.SET_LOCALE](state, locale): void {
    state.locale = locale;
  },
};
